import cookies from "js-cookie";
/**
 * 存储tokens
 * @param {string} accessToken
 * @param {string} refreshToken
 */
export function cookieGO(key, value, time) {
  // 存储tokens tokens只进入cookies，不进入vuex全局管理
  if (time) {
    var time_t = 1000 * time;
  } else {
    var time_t = 1000 * 60 * 60 * 24;
  }
  var today = new Date();
  var expires = new Date();
  expires.setTime(today.getTime() + time_t);
  window.document.cookie =
    key +
    "=" +
    escape(value) +
    ("; expires=" + expires.toGMTString()) +
    ";domain=.successkaoyan.com;path=/";
}

/**
 * 存储access_token
 * @param {string} cookieName
 * @param {string} cookieValue
 * @param {number} cookieDates
 */
// export function saveQuesRecord(cookieName, cookieValue, cookieDates) {
//   // cookies.set('access_token', `${accessToken}`)
//   var d = new Date();
//   d.setDate(d.getDate() + cookieDates);
//   document.cookie =
//     cookieName +
//     "=" +
//     cookieValue +
//     (";expires=" + d.toGMTString()) +
//     ";domain=.successkaoyan.com;path=/";
// }
// 存储学习记录
export function saveQuesRecord(cookieName, cookieValue) {
  localStorage.setItem(cookieName, cookieValue);
}
// 读取学习记录
export function getQuesRecord(cookieName) {
  return localStorage.getItem(cookieName);
}
// 读取学习记录
export function delQuesRecord(cookieName) {
  localStorage.removeItem(cookieName);
}
/**
 * 获得某个token
 * @param {string} tokenKey
 */
export function getCookie(name) {
  var findcookie = name + "=";
  if (window.document.cookie.length > 0) {
    // if there are any cookies
    let offset = window.document.cookie.indexOf(findcookie);
    if (offset != -1) {
      // if cookie exists
      offset += findcookie.length; // set index of beginning of value
      let end = window.document.cookie.indexOf(";", offset); // set index of end of cookie value
      if (end == -1) end = window.document.cookie.length;
      return unescape(window.document.cookie.substring(offset, end));
    }
  }
  return null;
  // return cookies.get(tokenKey)
}

/**
 * 移除token
 */
export function clearCookie(key) {
  var d = new Date();
  d.setTime(d.getTime() + -1 * 24 * 60 * 60 * 1000);
  window.document.cookie =
    key +
    '=""' +
    ("; expires=" + d.toGMTString()) +
    ";domain=.successkaoyan.com;path=/";
  // cookies.remove('access_token')
  // cookies.remove('refresh_token')
  // sessionStorage.removeItem('flag')
  // sessionStorage.clear()
  // localStorage.clear()
}

// 升序
export function compare(property) {
  return function (a, b) {
    var value1 = a[property];
    var value2 = b[property];
    return value1 - value2;
  };
}
// 降序
export function compare_down(property) {
  return function (a, b) {
    var value1 = a[property];
    var value2 = b[property];
    return value2 - value1;
  };
}

export function subNumToEn(num) {
  if (num == 0) {
    return "A";
  } else if (num == 1) {
    return "B";
  } else if (num == 2) {
    return "C";
  } else if (num == 3) {
    return "D";
  } else if (num == 4) {
    return "E";
  } else if (num == 5) {
    return "F";
  } else if (num == 6) {
    return "G";
  } else if (num == 7) {
    return "H";
  } else if (num == 8) {
    return "I";
  } else if (num == 9) {
    return "J";
  }
}

import { ke_host } from "@/request/config";
export function toLogin(str) {
  location.href = ke_host + "login?re_url=" + str;
}

export function closePage() {
  var userAgent = navigator.userAgent;
  // if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") != -1) {
  //   window.location.href = "about:blank";
  // } else {
    window.opener = null;
    // window.open("about:blank", "_self");
    window.close();
  // }
}
